import React from 'react'
import { MultipleChoiceQuestionDto } from '@professocialApi/professocial-core-frontend-api/models'
import {
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Checkbox,
  ListItemText,
  Stack,
  Paper
} from '@mui/material'

import RadioButtonUncheckedRoundedIcon from '@mui/icons-material/RadioButtonUncheckedRounded'
import CancelRoundedIcon from '@mui/icons-material/CancelRounded'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'

type Props = {
	question: MultipleChoiceQuestionDto
	setCurrentAnswers: (index: number, value?: boolean | undefined) => void
}

const UserQuizQuestion: React.FC<Props> = (props) => {
  const { question, setCurrentAnswers } = props
  const [checked, setChecked] = React.useState([0])

  const handleToggle = (value: number, correct: boolean) => () => {
    const currentIndex = checked.indexOf(value)
    const newChecked = [...checked]

    if (currentIndex === -1) {
      newChecked.push(value)
      setCurrentAnswers(value, correct)
    } else {
      newChecked.splice(currentIndex, 1)
      setCurrentAnswers(value)
    }

    setChecked(newChecked)
  }

  return (
    <>
      <Stack direction="row" spacing={4}>
        <img src={question.picture} height={200} alt=""/>
        <Paper variant="outlined" sx={{ p: 3, width: '100%' }}>
          <Typography>{question.questionText}</Typography>
        </Paper>

      </Stack>
      <List sx={{ width: '100%', pt: 3 }}>
        {question.answers?.map(answer =>
          <ListItem
            key={answer.id}
            secondaryAction={<Typography
              variant="body2">{checked.indexOf(answer.id) !== -1 && answer.responseText}</Typography>}
            disablePadding
          >
            <ListItemButton role={undefined} onClick={handleToggle(answer.id, answer.correct)} dense>
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={checked.indexOf(answer.id) !== -1}
                  icon={<RadioButtonUncheckedRoundedIcon/>}
                  checkedIcon={answer.correct ? <CheckCircleRoundedIcon color="success"/> :
                    <CancelRoundedIcon color="error"/>}
                  sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                  tabIndex={-1}
                  disableRipple
                />
              </ListItemIcon>
              <ListItemText id={question.id.toString()} primary={answer.answerText}/>
            </ListItemButton>
          </ListItem>
        )}
      </List>
    </>
  )
}

export default UserQuizQuestion
